import {
  DateString,
  Day,
  Month,
  Status,
  Year
} from '../api/services/orders/types.ts'
import { convertToShortDate } from './formatter.ts'

export const getCurrentDateAsString = (): DateString => {
  const now = new Date()

  const year: Year = now.getFullYear().toString() as Year // Get current year
  const month: Month = (now.getMonth() + 1).toString().padStart(2, '0') as Month // Get current month (0-based in JavaScript)
  const day: Day = now.getDate().toString().padStart(2, '0') as Day // Get current day

  return `${year}-${month}-${day}` as DateString
}

export const splitDateString = (dateTimeString: string) => {
  const [date, timeWithZone] = dateTimeString.split('T')
  const time = timeWithZone.split('+')[0].slice(0, 8)

  return { date, time }
}

export const calculateDaysBetweenDates = (date1: Date, date2: Date): number => {
  let differenceInMilliseconds = Math.floor(date2.getTime() - date1.getTime())
  let oneDay = 24 * 60 * 60 * 1000

  return Math.round(differenceInMilliseconds / oneDay)
}

export const convertDateStringToFullDate = (date: string) => {
  const newDate = new Date(date)
  newDate.setHours(0, 0, 0, 0)
  return newDate
}

export const convertDate = (date: Date) => {
  const year = date.getFullYear()
  const month = (1 + date.getMonth()).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  return year + '-' + month + '-' + day
}

export const addDaysToDate = (date: Date | undefined, days: number): Date => {
  if (!date) return new Date()
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export const checkRealizationDateWithCurrent = (
  dateString: Date,
  status: Status
) => {
  const inputDate = new Date(dateString)
  const currentDate = new Date()

  const inputDateFormat = inputDate.setHours(0, 0, 0, 0).toLocaleString()
  const currentDateFormat = currentDate.setHours(24, 0, 0, 0).toLocaleString()

  if (status === 'waiting_for_realization' || status === 'change_requested') {
    if (inputDateFormat > currentDateFormat) {
      return 'clear'
    } else if (inputDateFormat < currentDateFormat) {
      return 'overdue'
    } else if (inputDateFormat === currentDateFormat) {
      return 'today'
    }
  } else {
    return 'clear'
  }
}

export const getLatestDate = (date1: string, date2: string) => {
  const dateObject1 = new Date(date1)
  const dateObject2 = new Date(date2)

  if (dateObject1 > dateObject2) {
    return date1 // date1 is later
  } else if (dateObject2 > dateObject1) {
    return date2 // date2 is later
  } else {
    return date1
  }
}

export const getTomorrowShortDate = () => {
  const currentDay = new Date()
  const tomorrow = new Date(currentDay)
  tomorrow.setDate(currentDay.getDate() + 1)

  return convertToShortDate(tomorrow.toString()) as DateString
}

export const getCurrentMonthBoundaries = (): {
  firstDay: string
  lastDay: string
} => {
  const now = new Date()

  const year = now.getFullYear()
  const month = now.getMonth() + 1 // miesiące od 0 do 11

  // Pierwszy dzień
  const firstDay = `${year}-${String(month).padStart(2, '0')}-01`

  // Ostatni dzień
  const lastDayNum = new Date(year, month, 0).getDate()
  const lastDay = `${year}-${String(month).padStart(2, '0')}-${String(lastDayNum).padStart(2, '0')}`

  return { firstDay, lastDay }
}
